"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Coach {
    constructor(dateTimeProvider, ratingApi, capacityApi, coachUserApi, tokenService, strategy, coachInfoStrategy, monthlyOverview, conditionalCacheStrategy, dateTimeModifier) {
        this.getCapacity = () => this.capacityApi.getCapacity();
        this.setCapacity = (capacity) => this.capacityApi.setCapacity(capacity);
        this.getPersonalInformation = async () => {
            return await this.coachInfoStrategy.get("PERSONAL_INFORMATION", async () => {
                return this.tokenService
                    .getValidToken()
                    .then(this.coachUserApi.getPersonalInformation);
            }, null);
        };
        this.countAvailableCapacity = (capacityValues) => {
            return (capacityValues.maximum - capacityValues.reserved - capacityValues.taken);
        };
        this.getMonthlyCustomerOverview = async (year, month) => {
            return await this.conditionalCacheStrategy.get(`${year}.${month}`, async () => {
                return this.dateTimeModifier.isCurrentMonth(year, month);
            }, async () => await this.monthlyOverview.getMonthlyCustomerOverview(year, month));
        };
        this.dateTimeProvider = dateTimeProvider;
        this.ratingApi = ratingApi;
        this.capacityApi = capacityApi;
        this.coachUserApi = coachUserApi;
        this.tokenService = tokenService;
        this.strategy = strategy;
        this.coachInfoStrategy = coachInfoStrategy;
        this.monthlyOverview = monthlyOverview;
        this.conditionalCacheStrategy = conditionalCacheStrategy;
        this.dateTimeModifier = dateTimeModifier;
    }
    getRequest() {
        return this.tokenService
            .getValidToken()
            .then((_token) => this.ratingApi.getRatings());
    }
    getRatings(timeZone) {
        return new Promise((resolve, reject) => {
            const ratingsPromise = this.strategy.get("RATINGS", async () => this.getRequest());
            ratingsPromise
                .then((ratings) => ratings.map((rating) => ({
                ...rating,
                dateTime: this.dateTimeProvider.fromDateTime(rating.dateTime, timeZone),
            })))
                .then(resolve)
                .catch(reject);
        });
    }
}
exports.default = Coach;
//# sourceMappingURL=Coach.js.map